<template>
  <a-select
    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
    :value="modelValue"
    show-search
    :filter-option="false"
    :not-found-content="null"
    placeholder="Seleccionar usuario"
    @search="filterNames"
    @dropdownVisibleChange="handleChange"
    @change="selectUser"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <a-select-option :key="defaultBehavior ? '' : 0">Todos los usuarios</a-select-option>
    <a-select-option v-for="user in copyUsers" :key="user.id">
      {{ user.fullname }}
    </a-select-option>
  </a-select>
</template>

<script>
import { defineComponent, ref, computed, watch } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  props: {
    modelValue: {
      type: Number,
      required: true,
      default: undefined,
    },
    defaultBehavior: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const usersActive = computed(() => store.getters["getActiveUsers"]);
    const copyUsers = ref([]);
    const userSelected = ref(props.modelValue);

    watch(usersActive, (newValue) => {
      copyUsers.value = newValue;
    });

    return {
      usersActive,
      copyUsers,
      userSelected,
    };
  },
  async created() {
    await this.$store.dispatch("fetchActiveUsers");
    this.$emit("finishLoading");
  },
  methods: {
    filterNames(value) {
      value = value.toLowerCase();
      this.copyUsers = this.usersActive.filter((item) => {
        return item.fullname.toLowerCase().includes(value);
      });
    },
    handleChange() {
      this.copyUsers = this.usersActive;
    },
    selectUser(data) {
      let userSelect = this.usersActive.find((item) => item.id == data);
      this.$emit("onSelected", userSelect);
    },
  },
});
</script>

<style lang="sass" scoped>
.flag
  width: 20px
  margin-bottom: 2px
  margin-right: 4px
</style>
